import { render, staticRenderFns } from "./DescargarInforme.vue?vue&type=template&id=d0c9743a"
import script from "./DescargarInforme.vue?vue&type=script&lang=js"
export * from "./DescargarInforme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports